// The DOM attribute FieldShell stamps on its frame so Dropdown can anchor below it.
export const FIELD_FRAME_ATTR = "data-field-frame";
